<template>
    <div class="tr mp-promos__product">
        <div class="tr__upper align-items-start">
            <div class="tr__primary">
                <div class="tr-featured">
                    <div class="tr-featured__image tr-featured__image--product">
                        <img :src="product.dict_product.image.urls.small" class="img-fluid" />
                    </div>
                    <div class="tr-featured__details">
                        <span class="typo typo--label">EAN: {{product.dict_product.ean}}</span>
                        <p class="typo typo--name">{{product.dict_product.name}}</p>
                    </div>
                </div>
            </div>
            <div class="tr__secondary tr-data is-column">
                <div class="tr-data__cell">
                    <span class="tr-data__dt">Zwrot netto</span>
                    <span
                        class="tr-data__dd"
                        v-if="product.refund_total && product.refund_total[1]"
                    >{{ product.refund_total[0].toFixed(2) }} - {{ product.refund_total[1] | currency }}</span>
                    <span
                        class="tr-data__dd"
                        v-else-if="product.refund_total"
                    >{{ product.refund_total[0] | currency }}</span>
                    <span
                        class="tr-data__dd"
                        v-else-if="product.amount_of_refund"
                    >{{ product.amount_of_refund | currency }}</span>
                    <span class="tr-data__dd" v-else>---</span>
                </div>
                <div class="tr-data__cell">
                    <span class="tr-data__dt">Min. liczba</span>
                    <span class="tr-data__dd" v-if="product.count">{{ product.count }} szt.</span>
                    <span class="tr-data__dd" v-else>{{ minAmount }} szt.</span>
                </div>
                <div class="tr-data__cell" v-if="product.maximum_promotional_price !== undefined && !product.percentage_discount && showMaxPrice">
                    <span class="tr-data__dt">Max. cena</span>
                    <span
                        v-if="product.maximum_promotional_price"
                        class="tr-data__dd"
                    >{{ product.maximum_promotional_price | currency }}</span>
                    <span v-else class="tr-data__dd">---</span>
                </div>
                <div class="tr-data__cell" v-if="product.percentage_discount">
                    <span class="tr-data__dt">Rabat</span>
                    <span
                        class="tr-data__dd"
                    >{{ product.percentage_discount }} %</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true
        },
        setWeight: {
            type: String,
            required: false
        },
        showMaxPrice: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        minAmount() {
            if (this.product.count) {
                return this.product.count
            } else if (this.setWeight) {
                return Math.ceil(this.setWeight / this.product.weight)
            } else {
                return '---'
            }
        }
    }
}
</script>